import { createStore, applyMiddleware, compose, Store } from 'redux';
import createSagaMiddleware from 'redux-saga';

import { RootState, createRootReducer, rootSaga } from '../store';

const sagaMiddleware = createSagaMiddleware();

export default function configureStore(initialState: RootState): Store<RootState> {
  // create the composing function for our middlewares
  const composeEnhancers =
    process.env.NODE_ENV === 'development'
      ? window['__REDUX_DEVTOOLS_EXTENSION_COMPOSE__'] as typeof compose
      : (null || compose);
  // create the redux-saga middleware

  // We'll create our store with the combined reducers/sagas, and the initial Redux state that
  // we'll be passing from our entry point.
  const store = createStore(
    createRootReducer(),
    initialState,
    composeEnhancers ? composeEnhancers(applyMiddleware(sagaMiddleware)) : applyMiddleware(sagaMiddleware),
  );

  // Don't forget to run the root saga, and return the store object.
  sagaMiddleware.run(rootSaga);
  return store;
}
